function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M47.78 2.72L46.81 0H8L7 2.72c-4.27 12-9.93 32.5-5.29 47.2.22.71.47 1.41.74 2.09a24.44 24.44 0 002.75 5.07c2.87 4.08 7.54 6.91 12.93 8.47a36.08 36.08 0 006.73 1.28V103H8.78v5.22h38.07V103H30.3V66.78a36.49 36.49 0 006.31-1.23c5.41-1.55 10.11-4.38 13-8.47a24.82 24.82 0 003-5.93c.15-.4.29-.81.41-1.23 4.69-14.69-.96-35.19-5.24-47.2zM6 49.92a27.9 27.9 0 01-1.37-5.1l-.47-4c-.51-7.27.72-15.31 2.38-22.36a31.55 31.55 0 011-4c1.14-4.22 2.35-7.69 3.31-10.38V4H44c.93 2.6 2.1 6.34 3.2 10.38.65 1.94 1.12 4 1.12 4 1.67 7 2.9 15.08 2.39 22.36-.1 1.6-.46 4-.46 4a28.21 28.21 0 01-1.31 5v.14z",
  fill: "currentColor",
  "data-name": "Layer 1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 54.8 108.22"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/wine-small.svg";
export { SvgComponent as ReactComponent };